export const PX_QUESTION_GOAL_SELECTION_NAME = 'goal-selection';
export const PX_QUESTION_GOAL_SELECTION_COMPLETE_NAME = 'goal-selection-complete';

export const PX_QUESTION_GOAL_SELECTION_ANSWER_TYPES = {
	COMPLETE: 'COMPLETE',
	INCOMPLETE: 'INCOMPLETE',
};